import { useMutation } from '@apollo/client'
import {
  AuthLinkPasswordFinishMutation,
  AuthLinkPasswordFinishMutationVariables,
  AuthLinkPasswordStartMutation,
  AuthLinkPasswordStartMutationVariables,
  AuthPasswordResetFinishMutation,
  AuthPasswordResetFinishMutationVariables,
  AuthPasswordResetRequestMutation,
  AuthPasswordResetRequestMutationVariables,
  AuthSecondFactorMutation,
  AuthSecondFactorMutationVariables,
  ConsoleAppleUnlinkMutation,
  ConsoleAppleUnlinkMutationVariables,
  ConsoleAuthenticatorReplaceStartMutation,
  ConsoleAuthenticatorReplaceStartMutationVariables,
  ConsoleGoogleUnlinkMutation,
  ConsoleGoogleUnlinkMutationVariables,
  ConsolePasswordChangeMutation,
  ConsolePasswordChangeMutationVariables,
  ConsolePasswordEnrolFinishMutation,
  ConsolePasswordEnrolFinishMutationVariables,
  ConsolePasswordEnrolStartMutation,
  ConsolePasswordEnrolStartMutationVariables,
  ConsolePasswordRemoveMutation,
  ConsolePasswordRemoveMutationVariables,
  ConsoleRecoveryCodesRegenerateMutation,
  ConsoleRecoveryCodesRegenerateMutationVariables,
  ConsoleSignInResetMutation,
  ConsoleSignInResetMutationVariables,
} from 'src/generated'

import AUTHLINKPASSWORDFINISH from './authLinkPasswordFinish.gql'
import AUTHLINKPASSWORDSTART from './authLinkPasswordStart.gql'
import AUTHPASSWORDRESETFINISH from './authPasswordResetFinish.gql'
import AUTHPASSWORDRESETREQUEST from './authPasswordResetRequest.gql'
import AUTHSECONDFACTOR from './authSecondFactor.gql'
import CONSOLEAPPLEUNLINK from './consoleAppleUnlink.gql'
import CONSOLEAUTHENTICATORREPLACESTART from './consoleAuthenticatorReplaceStart.gql'
import CONSOLEGOOGLEUNLINK from './consoleGoogleUnlink.gql'
import CONSOLEPASSWORDCHANGE from './consolePasswordChange.gql'
import CONSOLEPASSWORDENROLFINISH from './consolePasswordEnrolFinish.gql'
import CONSOLEPASSWORDENROLSTART from './consolePasswordEnrolStart.gql'
import CONSOLEPASSWORDREMOVE from './consolePasswordRemove.gql'
import CONSOLERECOVERYCODESREGENERATE from './consoleRecoveryCodesRegenerate.gql'
import CONSOLESIGNINRESET from './consoleSignInReset.gql'

// ----------------------------------------------------------------------
// Signing in with a password, and changing how an account signs in.
//
// Never cached: every answer here is a secret shown once or a session.
// ----------------------------------------------------------------------

export const useAuthSecondFactorMutation = () =>
  useMutation<AuthSecondFactorMutation, AuthSecondFactorMutationVariables>(
    AUTHSECONDFACTOR,
    {
      fetchPolicy: 'no-cache',
      context: { anonymous: true },
    },
  )

export const useAuthPasswordResetRequestMutation = () =>
  useMutation<
    AuthPasswordResetRequestMutation,
    AuthPasswordResetRequestMutationVariables
  >(AUTHPASSWORDRESETREQUEST, {
    fetchPolicy: 'no-cache',
    context: { anonymous: true },
  })

export const useAuthPasswordResetFinishMutation = () =>
  useMutation<
    AuthPasswordResetFinishMutation,
    AuthPasswordResetFinishMutationVariables
  >(AUTHPASSWORDRESETFINISH, {
    fetchPolicy: 'no-cache',
    context: { anonymous: true },
  })

export const useAuthLinkPasswordStartMutation = () =>
  useMutation<
    AuthLinkPasswordStartMutation,
    AuthLinkPasswordStartMutationVariables
  >(AUTHLINKPASSWORDSTART, {
    fetchPolicy: 'no-cache',
    context: { anonymous: true },
  })

export const useAuthLinkPasswordFinishMutation = () =>
  useMutation<
    AuthLinkPasswordFinishMutation,
    AuthLinkPasswordFinishMutationVariables
  >(AUTHLINKPASSWORDFINISH, {
    fetchPolicy: 'no-cache',
    context: { anonymous: true },
  })

export const useConsolePasswordEnrolStartMutation = () =>
  useMutation<
    ConsolePasswordEnrolStartMutation,
    ConsolePasswordEnrolStartMutationVariables
  >(CONSOLEPASSWORDENROLSTART, {
    fetchPolicy: 'no-cache',
  })

export const useConsoleAuthenticatorReplaceStartMutation = () =>
  useMutation<
    ConsoleAuthenticatorReplaceStartMutation,
    ConsoleAuthenticatorReplaceStartMutationVariables
  >(CONSOLEAUTHENTICATORREPLACESTART, {
    fetchPolicy: 'no-cache',
  })

export const useConsolePasswordEnrolFinishMutation = () =>
  useMutation<
    ConsolePasswordEnrolFinishMutation,
    ConsolePasswordEnrolFinishMutationVariables
  >(CONSOLEPASSWORDENROLFINISH, {
    fetchPolicy: 'no-cache',
  })

export const useConsolePasswordChangeMutation = () =>
  useMutation<
    ConsolePasswordChangeMutation,
    ConsolePasswordChangeMutationVariables
  >(CONSOLEPASSWORDCHANGE, {
    fetchPolicy: 'no-cache',
  })

export const useConsolePasswordRemoveMutation = () =>
  useMutation<
    ConsolePasswordRemoveMutation,
    ConsolePasswordRemoveMutationVariables
  >(CONSOLEPASSWORDREMOVE, {
    fetchPolicy: 'no-cache',
  })

export const useConsoleRecoveryCodesRegenerateMutation = () =>
  useMutation<
    ConsoleRecoveryCodesRegenerateMutation,
    ConsoleRecoveryCodesRegenerateMutationVariables
  >(CONSOLERECOVERYCODESREGENERATE, {
    fetchPolicy: 'no-cache',
  })

export const useConsoleSignInResetMutation = () =>
  useMutation<ConsoleSignInResetMutation, ConsoleSignInResetMutationVariables>(
    CONSOLESIGNINRESET,
    {
      fetchPolicy: 'no-cache',
    },
  )

export const useConsoleGoogleUnlinkMutation = () =>
  useMutation<
    ConsoleGoogleUnlinkMutation,
    ConsoleGoogleUnlinkMutationVariables
  >(CONSOLEGOOGLEUNLINK, { fetchPolicy: 'no-cache' })

export const useConsoleAppleUnlinkMutation = () =>
  useMutation<ConsoleAppleUnlinkMutation, ConsoleAppleUnlinkMutationVariables>(
    CONSOLEAPPLEUNLINK,
    { fetchPolicy: 'no-cache' },
  )
